.chart { width: 100%; }
